import { useIsFetching } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import classes from './global-fetching-indicator.module.css';

/**
 * GlobalFetchingIndicator
 * Renders a thin animated bar at the top of the viewport while any react-query fetches are in progress.
 */
export function GlobalFetchingIndicator() {
  const isFetching = useIsFetching();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isFetching > 0) {
      setVisible(true);
    } else if (visible) {
      // Delay hiding slightly to avoid flicker on rapid query completion
      const timeout = setTimeout(() => setVisible(false), 250);
      return () => clearTimeout(timeout);
    }
  }, [isFetching, visible]);

  if (!visible) {
    return null;
  }

  return (
    <div
      aria-live="polite"
      aria-busy={isFetching > 0}
      className={`fixed left-0 top-0 z-[100] h-0.5 w-full ${classes.indicator}`}
    />
  );
}
